/** The error's own message (for errors from the shared fetch helpers, the server's reason), or `fallback` when it has none. */
export function errorText(error: unknown, fallback: string) {
  return error instanceof Error && error.message ? error.message : fallback;
}
